import React, { useState } from "react";
import getChatGptResponse from "./api/chatgpt";
import styled from "styled-components";

function App() {
  const [userInput, setUserInput] = useState("");
  const [messages, setMessages] = useState([]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (userInput.trim() === "") return;

    // Add user message to chat
    const newMessages = [...messages, { role: "user", text: userInput }];
    setMessages(newMessages);
    setUserInput(""); // Clear input field

    try {
      // Get ChatGPT response
      const chatGptReply = await getChatGptResponse(userInput);

      // Add assistant message (ChatGPT's reply) to chat
      setMessages([...newMessages, { role: "assistant", text: chatGptReply }]);
    } catch (error) {
      console.error("Error fetching GPT response", error);
    }
  };

  return (
    <AppContainer>
      <ChatContainer>
        <Header>Idea Clinics</Header>
        <MessagesContainer>
          {messages.map((msg, index) => (
            <Message key={index} role={msg.role}>
              <strong>{msg.role === "user" ? "You" : "ChatGPT"}:</strong>{" "}
              <div
                dangerouslySetInnerHTML={{
                  __html: msg.text,
                }}
              ></div>
            </Message>
          ))}
        </MessagesContainer>
        <InputContainer onSubmit={handleSubmit}>
          <Input
            type="text"
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
            placeholder="Type your message..."
            autoFocus
          />
          <Button type="submit">Send</Button>
        </InputContainer>
      </ChatContainer>
    </AppContainer>
  );
}

export default App;

// Styled Components for Layout and Design
const AppContainer = styled.div`
  font-family: Arial, Helvetica, sans-serif;
  background-color: #f4f7fa;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 0;
  margin: 0;
  height: 100vh;
  width: 100vw;
  box-sizing: border-box;
`;

const ChatContainer = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  background-color: #f17538;
  color: white;
  padding: 20px;
  text-align: center;
  font-size: 24px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

const MessagesContainer = styled.div`
  padding: 20px;
  flex: 1;
  overflow-y: auto;
  background-color: #f9f9f9;
  border-bottom: 2px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const Message = styled.div`
  margin-bottom: 15px;
  padding: 12px;
  border-radius: 8px;
  max-width: 80%;
  ${(props) =>
    props.role === "user"
      ? `
          background-color: #c8e6c9;
          align-self: flex-end;
        `
      : `
          background-color: #e1f5fe;
          align-self: flex-start;
        `}
`;

const InputContainer = styled.form`
  display: flex;
  padding: 10px;
  background-color: #ffffff;
  border-top: 2px solid #e0e0e0;
`;

const Input = styled.input`
  flex: 1;
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 30px;
  outline: none;
`;

const Button = styled.button`
  padding: 12px 20px;
  background-color: #f17538;
  color: white;
  border: none;
  border-radius: 30px;
  margin-left: 10px;
  cursor: pointer;
  &:hover {
    background-color: #e64a19;
  }
`;
